import { render, staticRenderFns } from "./ProductsColorsMaps.vue?vue&type=template&id=68974e3d&"
import script from "./ProductsColorsMaps.vue?vue&type=script&lang=js&"
export * from "./ProductsColorsMaps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports